// extracted by mini-css-extract-plugin
export default {"cardInfor":"accessibility_cardInfor__AyONT","body":"accessibility_body__bkadC","txt":"accessibility_txt__P4ARI"};